import { useRemoteData } from '@binhatch/hooks';
import { PromotionConfig } from 'flexinet-api';
import React from 'react';
import { useLocalStorage } from 'react-use';
import { createContainer } from 'unstated-next';

import { configurationApi, notificationApi } from '@/integrations/api';

import { Auth } from './useAuth';

interface RemoteConfiguration extends Partial<PromotionConfig> {}

interface LocalConfiguration {
  realtime: boolean;
}

const useConfiguration = () => {
  const { context } = Auth.useContainer();
  const [local, setLocal] = useLocalStorage<LocalConfiguration>('config', { realtime: false });

  const userId = context?.user.id;

  const features = useRemoteData({ key: 'useFeatures', skip: !userId, userId }, async ({ userId }) => {
    if (!userId) throw new Error('No user specified.');

    return configurationApi.listUserFeatures().then((r) => new Set(r.data.features));
  });

  const remote = useRemoteData({ key: 'useConfiguration', userId, skip: !userId }, async ({ userId }): Promise<RemoteConfiguration> => {
    if (!userId) throw new Error('No user specified.');

    const { promotionConfig } = await notificationApi.getUserPreferences().then((r) => r.data);

    return promotionConfig ?? {};
  });

  return React.useMemo(() => {
    return [
      {
        value: { ...local, ...remote.data, features: features.data },
        loading: remote.isLoading || features.isLoading
      },
      setLocal
    ] as const;
  }, [local, remote, features, setLocal]);
};

export const Configuration = createContainer(useConfiguration);
